import { render, staticRenderFns } from "./ConformacionCopass.Menor10.vue?vue&type=template&id=0876337a&"
import script from "./ConformacionCopass.Menor10.vue?vue&type=script&lang=js&"
export * from "./ConformacionCopass.Menor10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports